import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  get_indices3txodfl5wuu5j as get_indices,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { String$toString$ref18apr2asyof4x as String$toString$ref } from './LocalDateFormat.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { YearMonth22nahmknr467s as YearMonth } from '../YearMonth.mjs';
import { get_number11nqnpf0wxtuc as get_number } from '../Month.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import { BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure } from '../internal/format/FormatStructure.mjs';
import {
  WithYearMonth35cttdg68tw6f as WithYearMonth,
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  year$default3mx8s1e4np76f as year$default,
  monthNumber$defaultjiqg7b70p9la as monthNumber$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
  Padding_ZERO_getInstance165tawgk9tdj7 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance3jytkjkv2jvr6 as Padding_SPACE_getInstance,
} from './DateTimeFormat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SignedIntFieldFormatDirective2ce7tjucbhgd2 as SignedIntFieldFormatDirective,
  UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective,
  NamedUnsignedIntFieldFormatDirective1yq6ki9eqgm4v as NamedUnsignedIntFieldFormatDirective,
} from '../internal/format/FieldFormatDirective.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  GenericFieldSpecnllvuuqbuxsd as GenericFieldSpec,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_emptyIncompleteYearMonth() {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  return emptyIncompleteYearMonth;
}
var emptyIncompleteYearMonth;
function get_ISO_YEAR_MONTH() {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  var tmp0 = ISO_YEAR_MONTH$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_YEAR_MONTH', 0, tmp, _get_ISO_YEAR_MONTH_$ref_y3tv9a(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_YEAR_MONTH$delegate;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ENGLISH_FULL_1 = new (MonthNames())(listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']));
        this.ENGLISH_ABBREVIATED_1 = new (MonthNames())(listOf(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MonthNamesClass;
function MonthNames() {
  if (MonthNamesClass === VOID) {
    class $ {
      constructor(names) {
        Companion_getInstance();
        this.names_1 = names;
        // Inline function 'kotlin.require' call
        if (!(this.names_1.get_size_woubt6_k$() === 12)) {
          var message = 'Month names must contain exactly 12 elements';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.collections.forEach' call
        var progression = get_indices(this.names_1);
        var inductionVariable = progression.first_1;
        var last = progression.last_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ix = element;
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = this.names_1.get_c1px32_k$(ix);
            // Inline function 'kotlin.require' call
            if (!(charSequenceLength(this_0) > 0)) {
              var message_0 = 'A month name can not be empty';
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
            }
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < ix)
              do {
                var ix2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'kotlin.require' call
                if (!!(this.names_1.get_c1px32_k$(ix) === this.names_1.get_c1px32_k$(ix2))) {
                  var message_1 = "Month names must be unique, but '" + this.names_1.get_c1px32_k$(ix) + "' was repeated";
                  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
                }
              }
               while (inductionVariable_0 < ix);
          }
           while (!(element === last));
      }
      toString() {
        return joinToString(this.names_1, ', ', 'MonthNames(', ')', VOID, VOID, String$toString$ref());
      }
      equals(other) {
        var tmp;
        if (other instanceof MonthNames()) {
          tmp = equals(this.names_1, other.names_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.names_1);
      }
    }
    initMetadataForClass($, 'MonthNames');
    MonthNamesClass = $;
  }
  return MonthNamesClass;
}
var IncompleteYearMonthClass;
function IncompleteYearMonth() {
  if (IncompleteYearMonthClass === VOID) {
    class $ {
      constructor(year, monthNumber) {
        year = year === VOID ? null : year;
        monthNumber = monthNumber === VOID ? null : monthNumber;
        this.year_1 = year;
        this.monthNumber_1 = monthNumber;
      }
      set_year_8yykwv_k$(_set____db54di) {
        this.year_1 = _set____db54di;
      }
      get_year_woy26e_k$() {
        return this.year_1;
      }
      set_monthNumber_nufdv5_k$(_set____db54di) {
        this.monthNumber_1 = _set____db54di;
      }
      get_monthNumber_nb47ls_k$() {
        return this.monthNumber_1;
      }
      toYearMonth_ii3sag_k$() {
        var year = requireParsedField(this.year_1, 'year');
        var month = requireParsedField(this.monthNumber_1, 'monthNumber');
        return YearMonth().new_kotlinx_datetime_YearMonth_rc8qre_k$(year, month);
      }
      populateFrom_e9ixa8_k$(yearMonth) {
        this.year_1 = yearMonth.year_1;
        this.monthNumber_1 = get_number(yearMonth.get_month_ivc8d3_k$());
      }
      copy_1tks5_k$() {
        return new (IncompleteYearMonth())(this.year_1, this.monthNumber_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof IncompleteYearMonth()) {
          tmp_0 = this.year_1 == other.year_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.monthNumber_1 == other.monthNumber_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.year_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp = imul(tmp$ret$0, 31);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.monthNumber_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        return tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
      }
      toString() {
        var tmp0_elvis_lhs = this.year_1;
        var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this.monthNumber_1;
        return tmp + '-' + toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
      }
    }
    initMetadataForClass($, 'IncompleteYearMonth', IncompleteYearMonth);
    IncompleteYearMonthClass = $;
  }
  return IncompleteYearMonthClass;
}
function requireParsedField(field, name) {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  if (field == null) {
    throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Can not create a ' + name + ' from the given input: the field ' + name + ' is missing');
  }
  return field;
}
function year(padding) {
  return this.addFormatStructureForYearMonth_t4rp63_k$(new (BasicFormatStructure())(new (YearDirective())(padding)));
}
function monthNumber(padding) {
  return this.addFormatStructureForYearMonth_t4rp63_k$(new (BasicFormatStructure())(new (MonthDirective())(padding)));
}
function monthName(names) {
  return this.addFormatStructureForYearMonth_t4rp63_k$(new (BasicFormatStructure())(new (MonthNameDirective())(names)));
}
var AbstractWithYearMonthBuilderClass;
function AbstractWithYearMonthBuilder() {
  if (AbstractWithYearMonthBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithYearMonthBuilder', VOID, VOID, [WithYearMonth()]);
    AbstractWithYearMonthBuilderClass = $;
  }
  return AbstractWithYearMonthBuilderClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      build_xjwtmz_k$(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (YearMonthFormat())(builder.build_1k0s4u_k$());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.actualBuilder_1 = actualBuilder;
      }
      get_actualBuilder_7qypdo_k$() {
        return this.actualBuilder_1;
      }
      addFormatStructureForYearMonth_t4rp63_k$(structure) {
        return this.actualBuilder_1.add_b6pdwl_k$(structure);
      }
      createEmpty_8k9z67_k$() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).appendAlternativeParsingImpl_9hljk3_k$ = appendAlternativeParsingImpl;
    protoOf($).appendOptionalImpl_725ywl_k$ = appendOptionalImpl;
    protoOf($).chars_pe6iqb_k$ = chars;
    protoOf($).build_1k0s4u_k$ = build;
    protoOf($).year_dmdaiv_k$ = year;
    protoOf($).year$default_dp2ctv_k$ = year$default;
    protoOf($).monthNumber_xjkdp7_k$ = monthNumber;
    protoOf($).monthNumber$default_9sd2sh_k$ = monthNumber$default;
    protoOf($).monthName_asbkgr_k$ = monthName;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithYearMonthBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var YearMonthFormatClass;
function YearMonthFormat() {
  if (YearMonthFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.actualFormat_1 = actualFormat;
      }
      get_actualFormat_d0ha3y_k$() {
        return this.actualFormat_1;
      }
      intermediateFromValue_eaxafe_k$(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteYearMonth())();
        this_0.populateFrom_e9ixa8_k$(value);
        return this_0;
      }
      intermediateFromValue_816pep_k$(value) {
        return this.intermediateFromValue_eaxafe_k$(value instanceof YearMonth() ? value : THROW_CCE());
      }
      valueFromIntermediate_2revsy_k$(intermediate) {
        return intermediate.toYearMonth_ii3sag_k$();
      }
      valueFromIntermediate_60ox3m_k$(intermediate) {
        return this.valueFromIntermediate_2revsy_k$(intermediate instanceof IncompleteYearMonth() ? intermediate : THROW_CCE());
      }
      get_emptyIntermediate_lysuyr_k$() {
        return get_emptyIncompleteYearMonth();
      }
    }
    initMetadataForClass($, 'YearMonthFormat');
    YearMonthFormatClass = $;
  }
  return YearMonthFormatClass;
}
var YearDirectiveClass;
function YearDirective() {
  if (YearDirectiveClass === VOID) {
    class $ extends SignedIntFieldFormatDirective() {
      constructor(padding, isYearOfEra) {
        isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
        var tmp = YearMonthFields_getInstance().year_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 4 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, null, padding.equals(Padding_SPACE_getInstance()) ? 4 : null, 4);
        this.padding_1 = padding;
        this.isYearOfEra_1 = isYearOfEra;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof YearDirective()) {
          tmp_0 = this.padding_1.equals(other.padding_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.isYearOfEra_1 === other.isYearOfEra_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(this.padding_1.hashCode(), 31) + getBooleanHashCode(this.isYearOfEra_1) | 0;
      }
    }
    initMetadataForClass($, 'YearDirective');
    YearDirectiveClass = $;
  }
  return YearDirectiveClass;
}
var MonthDirectiveClass;
function MonthDirective() {
  if (MonthDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = YearMonthFields_getInstance().month_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof MonthDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'MonthDirective');
    MonthDirectiveClass = $;
  }
  return MonthDirectiveClass;
}
var MonthNameDirectiveClass;
function MonthNameDirective() {
  if (MonthNameDirectiveClass === VOID) {
    class $ extends NamedUnsignedIntFieldFormatDirective() {
      constructor(names) {
        super(YearMonthFields_getInstance().month_1, names.names_1, 'monthName');
        this.names_1 = names;
      }
      equals(other) {
        var tmp;
        if (other instanceof MonthNameDirective()) {
          tmp = equals(this.names_1.names_1, other.names_1.names_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.names_1.names_1);
      }
    }
    initMetadataForClass($, 'MonthNameDirective');
    MonthNameDirectiveClass = $;
  }
  return MonthNameDirectiveClass;
}
function YearMonthFieldContainer$_get_year_$ref_7j3zdj() {
  return constructCallableReference((p0) => p0.get_year_woy26e_k$(), 1, 0, 54);
}
function YearMonthFieldContainer$_set_year_$ref_kc0aub() {
  return constructCallableReference((p0, p1) => {
    p0.set_year_8yykwv_k$(p1);
    return Unit_instance;
  }, 2, 0, 55);
}
function YearMonthFieldContainer$_get_monthNumber_$ref_pn0wu5() {
  return constructCallableReference((p0) => p0.get_monthNumber_nb47ls_k$(), 1, 0, 56);
}
function YearMonthFieldContainer$_set_monthNumber_$ref_fjapbl() {
  return constructCallableReference((p0, p1) => {
    p0.set_monthNumber_nufdv5_k$(p1);
    return Unit_instance;
  }, 2, 0, 57);
}
var YearMonthFieldsClass;
function YearMonthFields() {
  if (YearMonthFieldsClass === VOID) {
    class $ {
      constructor() {
        YearMonthFields_instance = this;
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = YearMonthFieldContainer$_get_year_$ref_7j3zdj();
        tmp.year_1 = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('year', 1, tmp_0, tmp_1, YearMonthFieldContainer$_set_year_$ref_kc0aub())));
        var tmp_2 = this;
        var tmp_3 = KMutableProperty1();
        var tmp_4 = YearMonthFieldContainer$_get_monthNumber_$ref_pn0wu5();
        tmp_2.month_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('monthNumber', 1, tmp_3, tmp_4, YearMonthFieldContainer$_set_monthNumber_$ref_fjapbl())), 1, 12);
      }
    }
    initMetadataForObject($, 'YearMonthFields');
    YearMonthFieldsClass = $;
  }
  return YearMonthFieldsClass;
}
var YearMonthFields_instance;
function YearMonthFields_getInstance() {
  if (YearMonthFields_instance === VOID)
    new (YearMonthFields())();
  return YearMonthFields_instance;
}
function ISO_YEAR_MONTH$delegate$lambda() {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  var tmp = Companion_instance_0;
  return tmp.build_xjwtmz_k$(ISO_YEAR_MONTH$delegate$lambda$lambda);
}
function ISO_YEAR_MONTH$delegate$lambda$lambda($this$build) {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  $this$build.year$default_dp2ctv_k$();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.monthNumber$default_9sd2sh_k$();
  return Unit_instance;
}
function _get_ISO_YEAR_MONTH_$ref_y3tv9a() {
  return constructCallableReference(() => get_ISO_YEAR_MONTH(), 0, 0, 58);
}
var properties_initialized_YearMonthFormat_kt_fp0mk6;
function _init_properties_YearMonthFormat_kt__i0mmu0() {
  if (!properties_initialized_YearMonthFormat_kt_fp0mk6) {
    properties_initialized_YearMonthFormat_kt_fp0mk6 = true;
    emptyIncompleteYearMonth = new (IncompleteYearMonth())();
    ISO_YEAR_MONTH$delegate = lazy(ISO_YEAR_MONTH$delegate$lambda);
  }
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3rwcbkvzrbmti,
  Companion_instance_0 as Companion_instance31uyudsfwogxj,
  monthName as monthName3sdgh7ilodr1v,
  monthNumber as monthNumber1m6x1k5hwwmv0,
  year as year1lgww3hq6k77h,
  AbstractWithYearMonthBuilder as AbstractWithYearMonthBuilder24i9826zzgc8l,
  get_ISO_YEAR_MONTH as get_ISO_YEAR_MONTHnhzdbkah361r,
  IncompleteYearMonth as IncompleteYearMonth32an7l8nqz3oa,
  requireParsedField as requireParsedField387b2jr94jy2p,
};
//endregion

//# sourceMappingURL=YearMonthFormat.mjs.map
